import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d6a3780&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style1 from "./index.vue?vue&type=style&index=1&id=2d6a3780&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6a3780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6a3780')) {
      api.createRecord('2d6a3780', component.options)
    } else {
      api.reload('2d6a3780', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d6a3780&scoped=true", function () {
      api.rerender('2d6a3780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mp/wx-statistics/index.vue"
export default component.exports